import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  TableColumnsType,
  Modal,
  Image,
  Flex,
  PaginationProps,
} from "antd";
import "./DasTotalMatchModal.scss";
import { mixPostV1 } from "../../../services/mixin";
import { IMAGE_URL } from "../../../env";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";

interface Props {
  isShow?: boolean;
  onPopupClose?: () => void;
  dataView?: any;
}

const closeIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.86312 3.86363C4.03189 3.6949 4.26077 3.60012 4.49942 3.60012C4.73806 3.60012 4.96694 3.6949 5.13572 3.86363L8.99942 7.72733L12.8631 3.86363C12.9461 3.77767 13.0455 3.7091 13.1553 3.66194C13.2651 3.61477 13.3832 3.58994 13.5027 3.5889C13.6222 3.58786 13.7407 3.61063 13.8513 3.65589C13.9619 3.70114 14.0624 3.76797 14.1469 3.85247C14.2314 3.93697 14.2982 4.03746 14.3435 4.14807C14.3887 4.25867 14.4115 4.37719 14.4104 4.49669C14.4094 4.61619 14.3846 4.73429 14.3374 4.84409C14.2902 4.95389 14.2217 5.0532 14.1357 5.13623L10.272 8.99993L14.1357 12.8636C14.2997 13.0334 14.3904 13.2607 14.3883 13.4967C14.3863 13.7327 14.2916 13.9584 14.1248 14.1253C13.9579 14.2921 13.7322 14.3868 13.4962 14.3888C13.2602 14.3909 13.0329 14.3002 12.8631 14.1362L8.99942 10.2725L5.13572 14.1362C4.96598 14.3002 4.73863 14.3909 4.50266 14.3888C4.26668 14.3868 4.04095 14.2921 3.87408 14.1253C3.70721 13.9584 3.61256 13.7327 3.61051 13.4967C3.60846 13.2607 3.69918 13.0334 3.86312 12.8636L7.72682 8.99993L3.86312 5.13623C3.69439 4.96745 3.59961 4.73857 3.59961 4.49993C3.59961 4.26128 3.69439 4.0324 3.86312 3.86363Z"
      fill="#6B7280"
    />
  </svg>
);

const fallbackAvatar =
  "data:image/png;base64,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";
interface DataType {
  key: React.Key;
  appId?: string;
  customerName?: string;
  customerPhone?: string;
  customerFace?: string;
  customerTimer?: string;
  shift?: string;
}

const MatchDetailView: React.FC<Props> = (props) => {
  const { isShow = false, onPopupClose, dataView } = props;
  const [open, setOpen] = useState(isShow);
  const lastParamsRef = useRef<string>("");
  const [params, setParams] = useState<{
    limit: number;
    page_number: number;
  }>({
    limit: 50,
    page_number: 1,
  });
  const customPrevNext: PaginationProps["itemRender"] = (
    _,
    type,
    originalElement
  ) => {
    if (type === "prev") {
      return (
        <Flex align="center" gap={8}>
          <ArrowLeftOutlined />
          <span>Previous</span>
        </Flex>
      );
    }
    if (type === "next") {
      return (
        <Flex align="center" gap={8}>
          <span>Next</span>
          <ArrowRightOutlined />
        </Flex>
      );
    }
    return originalElement;
  };
  useEffect(() => {
    setOpen(isShow);
  }, [isShow]);

  const onClose = () => {
    setOpen(false);

    if (onPopupClose) {
      onPopupClose();
    }
  };

  const columns: TableColumnsType<DataType> = [
    {
      title: "Customer name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "App id",
      dataIndex: "appId",
      key: "appId",
    },
    {
      title: "Match",
      dataIndex: "customerPhone",
      key: "customerPhone",
    },
    {
      title: "Member Face",
      dataIndex: "customerFace",
      key: "customerFace",
      render: (text, record) => (
        <Flex align="center" gap={12}>
          {/* <img src={text} alt={record.customerName} className="avatar" /> */}
          {/* <Avatar size={40} src={text ? text : '/images/avatar/avatar1-40x40.png'}  /> */}
          <Image
            height={40}
            width={40}
            src={`${IMAGE_URL}${text}`}
            alt={record.customerName}
            preview={{
              src: `${IMAGE_URL}${text}`,
            }}
            fallback={fallbackAvatar}
            style={{ borderRadius: "50%", overflow: "hidden" }}
          />
          <span>{record.customerTimer}</span>
        </Flex>
      ),
    },
    {
      title: "Shift",
      dataIndex: "shift",
      key: "shift",
    },
  ];
  const [items, setItems] = useState([] as any);
  const [tableLoading, setTableLoading] = useState(false);
  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };
  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
    });
  };
  const getItems = async () => {
    setTableLoading(true);
    const apiParams = {
      ...params,
      report_id: dataView,
    } as any;
    const res = await mixPostV1(
      "/api/webAdmin/gListMatchByReportMain.php",
      apiParams
    );

    if (res.status === 1) {
      const result: any = [];
      res.data.map((item: any, index: any) =>
        result.push({
          ...item,
          key: `${item.customer_id}-${index}`,
          appId: item.customer_id,
          customerName: item.customer_name,
          customerPhone: item.amount,
          customerFace: item.face_checkin,
          customerTimer: item.time_checkin,
          shift: item.shift,
        })
      );
      setItems({
        ...items,
        list: result,
        total: res.totalRecord,
      });
      setTableLoading(false);
    }
  };
  useEffect(() => {
    if (params.limit > 0) {
      const paramsStr = JSON.stringify(params) + "_" + (dataView || "");
      if (lastParamsRef.current === paramsStr) return;
      lastParamsRef.current = paramsStr;
      getItems();
    }
  }, [params, dataView]);

  useEffect(() => {
    if (dataView && dataView !== 0) {
      setParams((prev) => {
        if (prev.limit === 50 && prev.page_number === 1) return prev;
        return {
          limit: 50,
          page_number: 1,
        };
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataView]);

  return (
    <Modal
      centered
      open={open}
      closeIcon={closeIcon}
      footer={null}
      className="rs-modal das-total-match-modal"
      rootClassName="rs-modal-root"
      onCancel={onClose}
    >
      <div className="title-mix">Bonus detail</div>
      <Table
        columns={columns}
        dataSource={items.list}
        className="rs-table table-text-nowrap match-height"
        loading={tableLoading}
        scroll={{ x: true }}
        pagination={{
          current: params.page_number,
          pageSize: params.limit,
          position: ["bottomCenter"],
          showSizeChanger: true,
          showTitle: false,
          total: items.total,
          itemRender: customPrevNext,
          onChange: (e) => onPageChange(e),
        }}
        onChange={onTableChange}
      />
    </Modal>
  );
};

export default MatchDetailView;
